import { SessionStorageKey } from '@/enums/session-storage-key'
import MainPageVue from '@/pages/main-page/MainPage.vue'
import AuthService from '@/services/auth'
import EdgeFunctionsWrapper from '@/services/edge-functions-wrapper'
import loadingIndicatorHelper from '@/services/loading-indicator-helper'
import SnackbarHelperService from '@/services/snackbar-helper'
import UserService from '@/services/user'
import type { Snack } from '@shared/interfaces/snack'
import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router'

async function getSnacks(to: RouteLocationNormalized): Promise<void> {
  try {
    const snackPackData = sessionStorage.getItem(SessionStorageKey.SNACK_PACK)
    let snackPack: Snack[]
    if (snackPackData) {
      snackPack = JSON.parse(snackPackData)
    } else {
      loadingIndicatorHelper.showLoading()
      const { id, token } = UserService.user.value!
      snackPack = await EdgeFunctionsWrapper.getSnacks(id, token)
    }

    to.meta.snackPack = snackPack
    sessionStorage.setItem(SessionStorageKey.SNACK_PACK, JSON.stringify(snackPack))
  } catch (e) {
    AuthService.logout()
    SnackbarHelperService.show(
      'Oops! Something went wrong while loading your profile. Please try again.'
    )
    throw e
  } finally {
    loadingIndicatorHelper.hideLoading()
  }
}

const router = createRouter({
  scrollBehavior() {
    return { top: 0 }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainPageVue
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../pages/profile-page/ProfilePage.vue')
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/'
    }
  ]
})

router.beforeEach(async (to) => {
  if (to.name === 'profile' && !UserService.user.value) {
    return { name: 'home' }
  }
})

router.beforeResolve(async (to) => {
  if (to.name === 'profile') {
    await getSnacks(to)
  }
})

router.onError((error: any, to: RouteLocationNormalized) => {
  if (to.name === 'profile') {
    router.push({ name: 'home' })
  }
})

export default router
